import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import RgfList from '../../components/lrf/listar/rgf';


function RgfScreen () {
    return (
        <Fragment>
            <Head titulo="Relatório de Gestão Fiscal - RGF"/>
            <Header />
            <Container>
                <RgfList />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default RgfScreen;